module.exports = __webpack_public_path__ + "img/MyBid.e8fd85cb.png";